import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const depositSignService = {
  isSessionExists,
  login,
  logout,
  readKey,
  signData,
  signHashes
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'deposit-sign'
};

function extract(r) {
  return r.data;
}

async function isSessionExists(depositSignUserSessionId: string) {
  return axios
    .get(`${model.baseUrl}${model.controller}/session-exists?depositSignUserSessionId=${depositSignUserSessionId || ''}`)
    .then(extract);
}

async function login(
  depositSignUserSessionId,
  clientId: string,
  login: string,
  password: string,
  googleReCaptchaResponse: string = '',
  recaptchaType: string = '') {
  return axios
    .post(
      `${model.baseUrl}${model.controller}/login`,
      { depositSignUserSessionId, clientId, login, password, googleReCaptchaResponse, recaptchaType })
    .then(extract);
}

async function logout(depositSignUserSessionId) {
  return axios
    .post(
      `${model.baseUrl}${model.controller}/logout`, { depositSignUserSessionId })
    .then(extract);
}

async function readKey(
  depositSignUserSessionId,
  keyId: string,
  keyPassword: string,
  googleReCaptchaResponse: string = '',
  recaptchaType: string = '') {
  return axios
    .post(
      `${model.baseUrl}${model.controller}/key/read`,
      { depositSignUserSessionId, keyId, keyPassword, googleReCaptchaResponse, recaptchaType })
    .then(extract);
}

async function signData(
  depositSignUserSessionId,
  keyId: string,
  keyPassword: string,
  data: string,
  appendData: boolean,
  googleReCaptchaResponse: string = '',
  recaptchaType: string = '') {
  return axios
    .post(
      `${model.baseUrl}${model.controller}/sign-data`,
      { depositSignUserSessionId, keyId, keyPassword, data, appendData, googleReCaptchaResponse, recaptchaType })
    .then(extract);
}

async function signHashes(
  depositSignUserSessionId,
  keyId: string,
  keyPassword: string,
  hashes: Array<{ id: string, data: string }>,
  googleReCaptchaResponse: string = '',
  recaptchaType: string = '') {
  return axios
    .post(
      `${model.baseUrl}${model.controller}/sign-hashes`,
      { depositSignUserSessionId, keyId, keyPassword, hashes, googleReCaptchaResponse, recaptchaType })
    .then(extract);
}
